<div class="filter-item">
  <a mat-button class="primary-menu-button" [matMenuTriggerFor]="propertyTypeFilter">
    <span class="pr-2" [class.primary-color]="!allTypesSelected">{{ menuLabel }}</span>
    <mat-icon iconPositionEnd class="menu-expand-icon">arrow_drop_down</mat-icon>
  </a>

  <mat-menu #propertyTypeFilter="matMenu" (closed)="onMenuClosed($event)">
    <div>
      <div class="ml-3"><b>Property Type</b></div>

      <button mat-menu-item (click)="$event.stopPropagation()">
        <mat-checkbox
          color="primary"
          class="primary-checkbox"
          [checked]="subTypeSelection.isEmpty()"
          (change)="toggleAllTypes($event.checked)">
          All
        </mat-checkbox>
      </button>

      @for (pt of propertyTypes; track pt.id) {
        <button mat-menu-item [matMenuTriggerFor]="propertySubTypeFilter" [matMenuTriggerData]="{ parentType: pt }">
          <mat-checkbox
            color="primary"
            class="primary-checkbox"
            [checked]="isTypeChecked(pt)"
            [indeterminate]="isTypeIndeterminate(pt)"
            (change)="toggleType(pt)">
            {{ pt.name }}
          </mat-checkbox>
        </button>
      }
    </div>

    <div class="flex-row space-between items-center px-2 py-2 sticky">
      <a color="primary" mat-button (click)="onClearClick()">Clear</a>
      <button mat-flat-button color="primary" mat-button (click)="onApplyClick()">Apply</button>
    </div>
  </mat-menu>

  <mat-menu #propertySubTypeFilter="matMenu">
    <ng-template matMenuContent let-parentType="parentType">
      @for (pst of parentType.subTypeList; track pst.id) {
        <button mat-menu-item (click)="$event.stopPropagation()">
          <mat-checkbox
            color="primary"
            class="primary-checkbox"
            [checked]="isSubTypeChecked(pst)"
            (change)="toggleSubType(pst)">
            {{ pst.name }}
          </mat-checkbox>
        </button>
      }
    </ng-template>
  </mat-menu>
</div>